var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-progress-linear", {
    staticStyle: { "pointer-events": "none" },
    attrs: { color: _vm.getProgressBarColor(_vm.internalValue), height: "25" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ value }) {
          return [_c("strong", [_vm._v(_vm._s(Math.ceil(value)) + "%")])]
        },
      },
    ]),
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v
      },
      expression: "internalValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }